import { render } from "./PostNotes.vue?vue&type=template&id=873341d0&ts=true"
import script from "./PostNotes.vue?vue&type=script&lang=ts"
export * from "./PostNotes.vue?vue&type=script&lang=ts"

import "./PostNotes.vue?vue&type=style&index=0&id=873341d0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QSpace});
